<template>
    <div>
      <v-select v-if="hasWarchers" outlined
        :multiple="isMultiple"
        v-model="selectedVMBoxes"
        :items="owners"
        :label="isMultiple ? $t('vmail.cfg.filter.selectBoxes') : $t('vmail.cfg.filter.selectBox')"
        prepend-inner-icon="mdi-account-cog"
        item-text="name"
        item-value="value">
        <template v-if="isMultiple" v-slot:selection="{ index, item }">
          <div v-if="index === 0" style="width: 100%;">
            {{ item.name }}
            {{ selectedVMBoxes.length > 1 ? `(+${selectedVMBoxes.length} ${$t('vmail.vmbSelectBoxesLabel')})` : '' }}
          </div>
        </template>
        <template v-if="isMultiple" v-slot:prepend-item>
          <v-list-item @click="selectAll">
            <v-list-item-action>
              <v-icon>{{ selectAllIcon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('cdrs.filter.allExtensions') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2"></v-divider>
        </template>
      </v-select>

    </div>
  </template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'watcher-select',
  props: {
    isMultiple: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      box: 'all',
      mailbox: ''
    }
  },
  computed: {
    ...mapGetters({
      hasWarchers: 'voicemails/hasWarchers',
      watchers: 'voicemails/watchers',
      activeWatchers: 'voicemails/activeWatchers',
      currentUserExten: 'settings/currentUserExten'
    }),
    haveWatchers () {
      return this.watchers?.length > 1
    },
    owners () {
      return this.watchers.map(w => ({
        name: `${w.first_name} ${w.last_name} <${w.username}>`,
        value: w.username
      }))
    },
    selectAllIcon: function () {
      if (this.watchers.length === this.activeWatchers.length) return 'mdi-checkbox-marked'
      if (this.watchers.length > 0 && this.watchers.length < this.activeWatchers.length) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    selectedVMBoxes: {
      get () {
        return this.activeWatchers.length === 0
          ? (this.currentUserExten ? [this.currentUserExten] : [])
          : [...new Set(this.activeWatchers.map(w => w.username))]
      },
      set (selected, oldValues) {
        const fallback = this.currentUserExten ? [this.currentUserExten] : []
        this.setActiveWatchers(selected.length === 0 ? fallback : selected)
        this.loadVoicemailsForUsers()
      }
    }
  },
  methods: {
    ...mapActions({
      setActiveWatchers: 'voicemails/setActiveWatchers',
      loadVoicemailsForUsers: 'voicemails/loadVoicemailsForUsers'
    }),
    selectAll: async function () {
      if (this.watchers.length === this.activeWatchers.length) {
        const fallback = this.currentUserExten ? [this.currentUserExten] : []
        this.setActiveWatchers(fallback)
      } else {
        this.setActiveWatchers([...new Set(this.watchers.map(w => w.username))])
      }
      this.loadVoicemailsForUsers()
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.currentUserExten && this.selectedVMBoxes.length === 0) {
        this.setActiveWatchers([this.currentUserExten])
      }
    }, 1500)
  }
}
</script>
<style scoped>
</style>
